import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { SearchFlag } from '../../../common/components/SearchHeader/types/FilterChoice';
import { Facets } from '../../../common/schema/hannibal/types.generated';
import { filterNulls } from '../../../common/util/filterNulls';
import { Option } from '../EnumFilter/RadioGroup/RadioGroup';
import { FilterPill } from '../FilterPill/FilterPill';
import { useOverlay } from '../overlay/OverlayContext';

interface Props {
  tags: Facets['tags'];
}

const labels: Record<SearchFlag, string> = {
  telehealth: 'Telehealth',
};

const optionFor = (flag: SearchFlag) => ({ label: labels[flag], value: flag });

export const ConsultationTypeFilter = ({ tags }: Props) => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();
  const { flag } = filters;

  const hasSelection = Boolean(flag);

  const telehealthAvailable = hasSelection || !tags || tags?.some(it => it.term === 'TELE_ENABLED');

  const options: Option<SearchFlag | undefined>[] = filterNulls([
    { label: 'Any', value: undefined },
    telehealthAvailable ? optionFor('telehealth') : null,
  ]);

  const handleClick = () => {
    setFilters({
      ...filters,
      flag: flag ? undefined : 'telehealth',
    });

    clear();
  };

  if (flag === undefined && options.length === 1) return null;

  /** FIXME: a stopgap to hide the telehealth-filter for date searches while it is broken */
  if (filters.onlineAppointments?.date !== undefined && flag === undefined) return null;

  return (
    <FilterPill
      trackingId={LinkId.FILTER_BY_CONSULTATION_TYPE_BUTTON}
      hasValue={flag !== undefined}
      onClick={handleClick}
    >
      Telehealth
    </FilterPill>
  );
};
